module.exports = __webpack_public_path__ + "img/day.ccc4871c.jpg";